<template>
  <div class="ppv-modal-footer">
    <button class="ppv-modal-footer-cancel" @click="handleCancel">
      {{ cancelLabel || $t('ppv.older_visits.btn_cancel') }}
    </button>
    <button
      class="ppv-modal-footer-confirm"
      data-analytics-skip
      :disabled="!isValid"
      @click="handleConfirm"
    >
      {{ confirmLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PpvModalFooter',
  props: {
    confirmLabel: {
      type: String,
      required: true,
    },
    cancelLabel: {
      type: String,
      default: '',
    },
    isValid: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['cancel', 'confirm'],
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
.ppv-modal-footer {
  padding: 0 32px 32px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  align-items: center;
}
.ppv-modal-footer-cancel {
  background: none;
  border: none;
  font-weight: 600;
  color: #4a5568;
  cursor: pointer;
  padding: 10px 20px;
}
.ppv-modal-footer-confirm {
  background: #06191e;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.05s;
}
.ppv-modal-footer-confirm:hover {
  opacity: 0.9;
}
.ppv-modal-footer-confirm:active {
  transform: scale(0.97);
}
.ppv-modal-footer-confirm:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  filter: grayscale(0.5);
}
</style>
